{
	"title": "Πολιτική Απορρήτου",
	"backTitle": "Πίσω"
}
